import React, {useState} from "react";
import {AggregateCablingManifestBySite} from "../plannedDeliveries/interface/AggregateCablingManifestBySite";
import {
    CollectionPreferences,
    CollectionPreferencesProps,
    Header,
    Pagination,
    TableProps, TextFilter
} from "@amzn/awsui-components-react-v3";
import {CABLING_TAB_TABLE_COLUMN_CONFIG} from "./CablingManifestTableConfig";
import {useCollection} from "@amzn/awsui-collection-hooks";
import {CablingManifestTabTableByCablingStatus} from "./interface/CablingManifestTabTableByCablingStatus";
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import Table from "@amzn/awsui-components-react-v3/polaris/table";
import {CABLING_MANIFEST_TABLE_CONSTANT, PLANNED_DELIVERIES_PAGE} from "../LmdpConstants";
import {TableEmptyState, TableNoMatchState} from "../common-component/table-common-component";
import {CablingStatusWiseItemsCount} from "./interface/CablingStatusWiseItemsCount";
import {getItemByCablingStatus} from "../helper/CablingManifestSummaryHelper";

export interface CablingManifestTableProps {
    items: AggregateCablingManifestBySite[],
    cablingStatus: string,
    isLoading: boolean,
    statusCount: (count: CablingStatusWiseItemsCount) => void
}

export default function CablingManifestSummaryTable(props: CablingManifestTableProps) {

    const threeWeekCablingForecastColumnDefinition: TableProps.ColumnDefinition<CablingManifestTabTableByCablingStatus>[] = CABLING_TAB_TABLE_COLUMN_CONFIG.map(columnConfig => {
        return {
            id: columnConfig.label,
            header: columnConfig.header,
            cell: columnConfig.cell,
            width: columnConfig.minWidth,
        }
    });

    const defaultPreferences: CollectionPreferencesProps.Preferences<any> = {pageSize: 10};
    const [preferences, setPreferences] = useState(defaultPreferences);

    const {items, paginationProps, actions, filterProps} = useCollection(
        getItemByCablingStatus(props.items, props.cablingStatus, props.statusCount),
        {
            pagination: {pageSize: preferences.pageSize},
            filtering: {
                empty: <TableEmptyState resourceName={"Cabling Manifest"}/>,
                noMatch: <TableNoMatchState onClearFilter={() => actions.setFiltering('')}/>,
            }
        },
    );

    return (
        <Table
            columnDefinitions={threeWeekCablingForecastColumnDefinition}
            items={items}
            loadingText={PLANNED_DELIVERIES_PAGE.RESULT.TABLE.LOADING_TEXT}
            loading={props.isLoading}
            empty={
                <Box textAlign="center" color="inherit">
                    <b>No data available</b>
                </Box>
            }
            header={
                <Header>{CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_AGGREGATE_TABLE_HEADER + props.cablingStatus}</Header>
            }
            filter={
                <TextFilter
                    {...filterProps}
                    filteringPlaceholder={'Search with site'}
                />
            }
            pagination={<Pagination {...paginationProps} />}
            variant="embedded"
            preferences={
                <CollectionPreferences
                    title="Preferences"
                    confirmLabel="Confirm"
                    cancelLabel="Cancel"
                    disabled={false}
                    preferences={preferences}
                    pageSizePreference={{
                        title: "Page size",
                        options: [
                            {value: 10, label: "10 deliveries"},
                            {value: 30, label: "30 deliveries"},
                            {value: 50, label: "50 deliveries"},
                            {value: 100, label: "100 deliveries"},
                            {value: 300, label: "300 deliveries"}
                        ]
                    }}
                    onConfirm={({detail}) => {
                        return setPreferences(detail);
                    }}
                />
            }
        />
    )
}